$(document).ready(function(){
    $('#wlm-pwd').attr('aria-label', 'Enter passcode');
    $('.price-range__input-min[name="filter.v.price.gte"]').attr('aria-label', 'Minimum price');

$('.price-range__input-max[name="filter.v.price.lte"]').attr('aria-label', 'Maximum price');



$("div.grid-product__tag.grid-product__tag--sold-out").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });

$("div.grid-product__tag.grid-product__tag--sale").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });
$('select[name="id"][data-product-select].product-single__variants').attr(
    'aria-label',
    'Product variant'
);

$('img[src="//www.xeric.com/cdn/shop/files/xeric-omnigraph-cream-00-1x1_small.jpg?v=1764018473"]').attr('alt', 'Xeric Omnigraph watch in cream');

$('img[src="//www.xeric.com/cdn/shop/files/xeric-omnigraph-white-blue-00-1x1_small.jpg?v=1764018451"]').attr('alt', 'Xeric Omnigraph watch in white and blue');

$('img[src="//www.xeric.com/cdn/shop/files/xeric-omnigraph-black-00-1x1_small.jpg?v=1764018461"]').attr('alt', 'Xeric Omnigraph watch in black');

$('img[src="//www.xeric.com/cdn/shop/files/xeric-omnigraph-blue-tan-00-1x1_small.jpg?v=1764018482"]').attr('alt', 'Xeric Omnigraph watch in blue and tan');

$('img[src="//www.xeric.com/cdn/shop/files/xeric-omnigraph-mint-blue-00-1x1_small.jpg?v=1764018419"]').attr('alt', 'Xeric Omnigraph watch in mint and blue');

$('img[src="//www.xeric.com/cdn/shop/files/xeric-omnigraph-bronze-00-1x1_small.jpg?v=1764018489"]').attr('alt', 'Xeric Omnigraph watch in bronze');

$('img[src="//www.xeric.com/cdn/shop/files/xeric-omnigraph-spearmint-white-00-1x1_small.jpg?v=1764019399"]').attr('alt', 'Xeric Omnigraph watch in spearmint and white');

$('.custom-section-product-styles-slider a[href*="/products/"] img').each(function() {
    var img = $(this);
    var productUrl = img.closest('a').attr('href');

    if (productUrl) {
        var productName = productUrl
            .split('/products/')[1]
            .split('?')[0]
            .replace(/-(ivr|scr|Twh|V2a|Xvx|Hl3|I2a|Apa|Ata|Voy|Rgl|Hc3|H2c|Hcs|Atc|Tsn|Copy|Apm)-.*/i, '')
            .replace(/-/g, ' ')
            .replace(/\b\w/g, function(letter) {
                return letter.toUpperCase();
            });

        img.attr('alt', productName);
    }
});

$('a[href="https://cdn.shopify.com/s/files/1/0068/1675/9872/files/AtlasphereGMT-Instructions.pdf?7158384360088872041"]')
    .attr('aria-label', 'Atlasphere GMT Instructions PDF');
    setTimeout(() => {
      


    }, 1000);
$("button#contact-form-submit-template--18325360541874__form").each(function() {
    var link = $(this);
    var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
    link.html(spanElement);
});
/*
$("#shopify-section-template--18325360869554__text_columns_iFVht6 a[href='/collections/timeline-retrograde-automatic-watches']").each(function() {
    var link = $(this);
    var linkText = link.find("span[data-add-to-cart-text]").text().trim() || link.text().trim();
    var spanElement = $('<span>').text(linkText).addClass('bc');
    link.html(spanElement);
});
$("#shopify-section-template--18325360869554__text_columns_iFVht6 a[href='/collections/volta-double-retrograde-watches']").each(function() {
    var link = $(this);
    var linkText = link.find("span[data-add-to-cart-text]").text().trim() || link.text().trim();
    var spanElement = $('<span>').text(linkText).addClass('bc');
    link.html(spanElement);
});
$("#shopify-section-template--18325360869554__text_columns_iFVht6 a[href='/collections/coming-back-soon']").each(function() {
    var link = $(this);
    var linkText = link.find("span[data-add-to-cart-text]").text().trim() || link.text().trim();
    var spanElement = $('<span>').text(linkText).addClass('bc');
    link.html(spanElement);
});

$("#shopify-section-template--18325360869554__text_columns_iFVht6 a[href='/collections/omnigraph-automatic-watches']").each(function() {
    var link = $(this);
    var linkText = link.find("span[data-add-to-cart-text]").text().trim() || link.text().trim();
    var spanElement = $('<span>').text(linkText).addClass('bc');
    link.html(spanElement);
});
*/
$('a[href="/collections/omnigraph-automatic-watches"]').attr('aria-label', 'Omnigraph Automatic Watches');

$('a[href="/collections/coming-back-soon"]').attr('aria-label', 'Coming Back Soon');

$('a[href="/collections/timeline-retrograde-automatic-watches"]').attr('aria-label', 'Timeline Retrograde Automatic Watches');

$('a[href="/collections/volta-double-retrograde-watches"]').attr('aria-label', 'Volta Double Retrograde Watches');
$('textarea[name="h-captcha-response"]').attr('aria-label', 'hCaptcha response');
$("button[type='submit'][name='add'][data-add-to-cart].btn.btn--full.add-to-cart>span[data-default-text='Pre-order']").each(function() {
    var link = $(this);
    var linkText = link.text().trim();
    var spanElement = $('<span>').text(linkText).addClass('bc');
    link.html(spanElement);
});

let Intervaltime_google;
let counter_google = 0; 


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;
$('img[src^="https://bat.bing.com/action/"]').attr('alt', 'Microsoft Bing tracking pixel');
$('img[src="https://fonts.gstatic.com/s/i/productlogos/translate/v14/24px.svg"]').attr('alt', 'Google Translate');
 $('input[name="email"]').attr('aria-label', 'Enter Email address');

$('input[name="orderNumber"]').attr('aria-label', 'Enter Order number'); 
$('img[src^="https://bat.bing.com/action/"]').attr('alt', 'Microsoft Bing tracking pixel');
   $('.tmenu_indicator_icon svg').attr('aria-hidden', 'true');
$('.flickity-button svg.flickity-button-icon').attr('aria-hidden', 'true');
    if ( $('#goog-gt-votingInputSrcLang').length) {

$("label.adb-switch").append('<span style="display:none">.</span>');

$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
    
        clearInterval(Intervaltime_google);
       
    }
    
  
    if (counter_google >= 20) {
        clearInterval(Intervaltime_google);
       
    }
}
$('label[for="Search"]').removeAttr('for');
$('input.search__input').attr('aria-label', 'Search');

$("h3:empty").append("<span style='display:none'>.</span>");
$("h4:empty").append("<span style='display:none'>.</span>");
$('img[src="//www.xeric.com/cdn/shop/files/xeric-regulator-1968-automatic-vintage-mint-10.jpg?v=1791317100&amp;width=1080"]').attr('alt', 'Xeric Regulator 1968 Automatic Vintage Mint watch');

$('a[href="https://www.kickstarter.com/projects/watchismo/xeric-regulator-1968-automatic-watch?ref=10afcw"]').attr('aria-label', 'View Xeric Regulator 1968 Automatic Watch on Kickstarter');

console.log("ready");
});